import React from "react";
import { mdiShieldAlertOutline, mdiCogOutline } from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";
import { SAMPLE_REPORT_URL } from "../../constants/global-constants";
import "./disclaimerHowItWorksModal.css";

const ROWS = [
  {
    icon: mdiShieldAlertOutline,
    body: (
      <p>
        The content you edit here will appear in the{" "}
        <strong>'Inspection Scope &amp; Disclaimer'</strong> section of all
        future reports you compile.{" "}
        <a
          href={SAMPLE_REPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary"
          style={{ textDecoration: "underline" }}
        >
          See sample report
        </a>
      </p>
    ),
  },
  {
    icon: mdiCogOutline,
    body: (
      <p>You can choose to show or hide this section for all future reports.</p>
    ),
  },
];

const DisclaimerHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How Disclaimer Setting Works"
    rows={ROWS}
    className="disclaimer-how-it-works-modal-wrapper"
  />
);

export default DisclaimerHowItWorksModal;
